module.exports = __webpack_public_path__ + "img/option-1-preview.ce0cffe0.png";